function GetTopicDetails() {
}

module.exports = GetTopicDetails;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/get-topic-details/get-topic-details.js
// module id = 295
// module chunks = 1